import React, { Component } from "react";
import { DNRDModel } from "@my-dld/tabuapi";
import Strings from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AppConstants } from "../../configApp";
import { BaseLoginCard, BaseLoginScreen } from "../Login/BaseLoginScreen";

interface Props extends RoutedViewProps<{ id: string; }> {
}

interface State {
	data?: DNRDModel;
	referenceNumber: string;
}

export class SuccessRegister extends Component<Props, State> {
	constructor( props: any ) {
		super( props );
		this.state = {
			referenceNumber: props.match.params.id,
		};
	}

	render() {
		return <BaseLoginScreen>
			<BaseLoginCard id={ "rgOk" }>
				<div className="success-msg" id="successMsg" style={ { marginTop: "46px" } }>
					<div className="col-md-12 text-center">
						<div className="mb-3 d-flex justify-content-center green">
							<div className="svg-check-icon"/>
							<div
								className="reg-success-text"
								style={ { fontSize: "24px" } }>{ Strings.txt_success }</div>
						</div>
						<p>{ Strings.owner_regi }</p>
						<span className="reg-ref-number">
                                    { Strings.reference_number } : { this.state.referenceNumber }
                                </span>
						<br/>
						<a onClick={ this.goHome } className="btn btn_1">{ Strings.home }</a>
					</div>
				</div>
			</BaseLoginCard>
		</BaseLoginScreen>;
	}

	goHome = () => {
		window.location.href = AppConstants.rootUrlLocale;
	};
}
